import { Header } from "../components/header";
import MangroveGreenPeas from "../assets/mangrove-green-peas.png";
import MangroveSweetCorn from "../assets/mangrove-sweet-corn.png";
import { ProductDetails } from "../components/product-details";
import { createClient } from "contentful";
import { useEffect, useState } from "react";
import { PageLoadingShimmer } from "../components/page-loading";
import { handleAppError } from "../utils/error-handler";
import { Footer } from "../components/footer";

export function Products() {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);

  const client = createClient({
    space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
    accessToken: process.env.REACT_APP_CONTENTFUL_API_KEY,
  });

  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchProducts = async () => {
    try {
      const { items } = await client.getEntries({
        content_type: "mangroveProducts",
        order: "sys.createdAt",
      });
      setProducts([...items]);
    } catch (error) {
      handleAppError(error);
    } finally {
      setPageLoading(false);
    }
  };

  const randomImage = () => {
    const randomNumber = Math.floor(Math.random() * 50);
    if (randomNumber % 3)
      return { img: MangroveSweetCorn, name: "Mangrove Sweet Corn" };
    return { img: MangroveGreenPeas, name: "Mangrove Green Peas" };
  };

  return (
    <div className='products'>
      <Header />
      {pageLoading ? (
        <PageLoadingShimmer />
      ) : (
        <div className='products-list-page'>
          <div className='products-list'>
            {[...products].map((el, index) => {
              const { img, name } = randomImage();
              return (
                <div
                  className='product-wrapper'
                  type='button'
                  data-bs-toggle='offcanvas'
                  data-bs-target='#offcanvasExample'
                  aria-controls='offcanvasExample'
                  key={index}
                  onClick={() => setSelectedProduct(el)}
                >
                  <div className='product-img-wrapper'>
                    <img
                      className='img-fluid'
                      alt={"product-img"}
                      src={el?.fields?.image?.fields?.file?.url ?? img}
                    />
                  </div>
                  <p className='price'>
                    ${Number(el?.fields?.productPrice ?? 0).toFixed(2)}
                  </p>
                  <p className='name'>{el?.fields?.productName ?? name}</p>
                  <p className='sizes'>
                    Available Sizes:{" "}
                    {el?.fields?.sizes ? (
                      <b>{el?.fields?.sizes}</b>
                    ) : (
                      "All Sizes"
                    )}
                  </p>
                  <p className='short-description'>
                    {el?.fields?.shortDescription ??
                      el?.fields?.longDescription ??
                      "Lorem ipsum dolor sit amet. Quo neque dolores ea optio odio quo quibusdam voluptate qui quibusdam quia. Id accusantium tempora 33 natus amet eos totam atque sit incidunt nisi."}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <ProductDetails selectedProduct={selectedProduct} />
      <Footer />
    </div>
  );
}
